<template>
    <div class="bookList" @scroll.passive="onScroll" ref="boxH">
        <ul ref="scrollH">
            <li v-for="item in bookList" :key="item.id" @click="goBookInfo(item.id)">
                <img :src="item.cover" alt="">
                <div>
                    <p class="bookName">{{item.name}}</p>
                    <p class="bookDescribe">{{item.summary}}</p>
                    <div>
                        <div>{{item.countPlay}}次</div>
                        <div>{{item.countChapter}}集</div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>

export default {
    // name: "首页更多列表"
    data() {
        return {
            bookList: [],
            scrollH: 0,
            getMoreList: true,
            type: "",
            themeId: -1,
            pageNum: 1,
            pages: 0,
        }
    },
    created() {
        var that = this;
        // console.log(that.$route.query)
        that.type = that.$route.query.type;
        that.themeId = that.$route.query.themeId;
        if( that.type == "hotlis" ) {
            that.getHotlis();
        }else if( that.type == "newest" ) {
            that.getNewsList();
        }else if( that.type == "theme" ) {
            that.getThemeList();
        }
    },
    methods: {
        getThemeList() {
            var that = this;
            var data = {
                pageNum: that.pageNum,
                pageSize: 10
            };
            that.allApi.getThemeList(that.themeId, data).then((resource)=>{
                // console.log(JSON.parse(resource.data));
                if( that.pageNum == 1 ){
                    that.pages = JSON.parse(resource.data).t.pages;
                    that.bookList = JSON.parse(resource.data).t.list;
                }else {
                    that.bookList = that.bookList.concat(JSON.parse(resource.data).t.list);
                }
                that.$nextTick(()=>{
                    that.getMoreList = true;
                    that.scrollH = that.$refs.scrollH.offsetHeight;
                })
            })
        },
        getHotlis() {
            var that = this;
            that.allApi.getHotlis(that.pageNum, 10).then((resource)=>{
                // console.log(JSON.parse(resource.data));
                if( that.pageNum == 1 ){
                    that.pages = JSON.parse(resource.data).t.pages;
                    that.bookList = JSON.parse(resource.data).t.list;
                }else {
                    that.bookList = that.bookList.concat(JSON.parse(resource.data).t.list);
                }
                that.$nextTick(()=>{
                    that.getMoreList = true;
                    that.scrollH = that.$refs.scrollH.offsetHeight;
                })
            })
        },
        getNewsList() {
            var that = this;
            that.allApi.getNewsList(that.pageNum, 10).then((resource)=>{
                // console.log(JSON.parse(resource.data));
                if( that.pageNum == 1 ){
                    that.pages = JSON.parse(resource.data).t.pages;
                    that.bookList = JSON.parse(resource.data).t.list;
                }else {
                    that.bookList = that.bookList.concat(JSON.parse(resource.data).t.list);
                }
                that.$nextTick(()=>{
                    that.getMoreList = true;
                    that.scrollH = that.$refs.scrollH.offsetHeight;
                })
            })
        },
        goBookInfo(id) {
            this.$router.push({ path: `/bookInfo/${id}` });
        },
        onScroll() {
            var that = this;
            var boxH = that.$refs.boxH.offsetHeight;
            var boxTop = that.$refs.boxH.scrollTop;
            if( that.scrollH - boxH - boxTop < 30 && that.getMoreList ) {
                if( that.pageNum + 1 > that.pages ){
                    that.pageNum = that.pages;
                    return false;
                }else{
                    that.getMoreList = false;
                    that.pageNum ++;
                    if( that.type == "hotlis" ) {
                        that.getHotlis();
                    }else if( that.type == "newest" ) {
                        that.getNewsList();
                    }else if( that.type == "theme" ) {
                        that.getThemeList();
                    }
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.bookList{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    z-index: 2;
    background: #fff;
    padding-left: rem(30px);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    >ul{
        >li{
            overflow: hidden;
            display: flex;
            >img{
                width: rem(150px);
                height: rem(150px);
                margin: rem(40px) rem(32px) rem(40px) 0;
                background: #000;
                border-radius: rem(8px);
            }
            >div{
                width: 0%;
                flex: 1;
                padding: rem(40px) 0;
                border-bottom: 2px solid #efeff3;
                >.bookName{
                    font-size: rem(36px);
                    color: #333;
                    margin-bottom: rem(24px);
                    line-height: rem(36px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                >.bookDescribe{
                    font-size: rem(26px);
                    color: #a4a4b7;
                    margin-bottom: rem(36px);
                    line-height: rem(26px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                >div{
                    font-size: rem(26px);
                    color: #a4a4b7;
                    line-height: rem(26px);
                    overflow: hidden;
                    >div{
                        float: left;
                        background: url('../assets/imgs/bookList/play.png') center left / rem(18px) rem(18px) no-repeat;
                        padding-left: rem(28px);
                        &:last-child{
                            background: url('../assets/imgs/bookList/chapterNum.png') center left / rem(18px) rem(18px) no-repeat;
                            margin-left: rem(30px);
                        }
                    }
                }
            }
        }
    }
}
</style>
